<template>
    <div class="flex gap-3">
        <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
            <feather-icon icon="EditIcon" svgClasses="h-5 w-5 text-primary cursor-pointer" @click="editRecord"/>
        </vx-tooltip>

        <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
            <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 text-danger cursor-pointer"
                          @click="confirmDeleteRecord"/>
        </vx-tooltip>
    </div>
</template>

<script>
export default {
    name: 'CellRendererActions',
    methods: {
        editRecord() {
            this.$router.push(`/admin/manage-organization/edit?id=${this.params.data.id}`).catch(() => {
            });

            this.$store.commit('ORGANIZATION_UPDATE_INFO', this.params.data);
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá tổ chức "${this.params.data.name}"`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$oauth.post(`/organization/admin/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                return this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$store.commit('UPDATE_ORGANIZATION_SUCCESS', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá tổ chức thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>
